// src/auth/useAuthUser.ts
//
// Single source of truth for Firebase auth state in the UI layer.
// Replaces the duplicated onAuthStateChanged listeners scattered across
// Settings, SessionGate, etc. Returns the user plus a loading flag so
// guards can avoid flashing a redirect before auth resolves.

import { useEffect, useState } from 'react';
import { onAuthStateChanged, type User } from 'firebase/auth';
import { auth } from '../lib/firebase';

export interface AuthUserState {
	user: User | null;
	loading: boolean;
}

export function useAuthUser(): AuthUserState {
	const [user, setUser] = useState<User | null>(auth.currentUser);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const unsub = onAuthStateChanged(auth, (u) => {
			setUser(u);
			setLoading(false);
		});
		return unsub;
	}, []);

	return { user, loading };
}
